'use client';

import { Box, type SxProps } from '@mui/material';
import { flatSx, FlexColumn } from '@ocodelib/mui';
import { useEffect, useRef } from 'react';
import { useJsBasicApp } from '../../useJsBasicApp';
import { LogContainer } from './LogContainer';

interface Props {
  sx?: SxProps;
}

export function LayoutRightPane(props: Props) {
  const { sx } = props;
  const { app } = useJsBasicApp();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    app.setExecIframeDom(iframeRef.current);
  }, [app]);

  return (
    <FlexColumn
      className="LayoutRightPane-root"
      sx={flatSx(
        {
          height: '100%',
          position: 'relative',
          overflow: 'auto',
          '& > iframe': {
            flex: 1,
            width: '100%',
            height: 0,
          },
        },
        sx,
      )}
    >
      <Box component="iframe" ref={iframeRef} frameBorder="none" />
      {/* <Box component="iframe" ref={setIframe} src="http://localhost:9012/p5" frameBorder="none" /> */}
      <LogContainer
        sx={{
          width: '100%',
          height: '100%',
          maxHeight: 'auto',
        }}
      />
    </FlexColumn>
  );
}
